import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NameRunwayFileEnum } from '@shared/models/parking-zone.model';
import { ParkingLineFromApiMapper, ParkingLoadingZoneFromApiMapper, ParkingSpotFromApiMapper } from '@shared/utils/mappers/geo-api-map';
import { MapLayers } from '@shared/utils/mappers/layers-map.model';
import { GeometryTypeEnum, ILayerModel } from '@types-custom/models/business/marker.model';
import { FeatureCollection, MultiPolygon } from 'geojson';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParkingService {
  // linesFilterNotifier$ = new Subject<{lineData: any, spotData: any}>();
  linesFilterNotifier$ = new Subject<any>();
  filter$ = new BehaviorSubject<{ source: MapLayers, filters: any }>(undefined);
  private parkingUrl: string;
  private runwayUrl: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) {
    this.parkingUrl = this.environment.parkingUrl;
    this.runwayUrl = this.environment.runwayUrl;
  }

  getParkingZoneSpotGeoJson(): Observable<any> {
    const url = `${this.parkingUrl}/parking-spot/format-geo-json`;
    //const url = 'assets/mock/parking-spot.json';
    return this.httpClient.get<any[]>(url);
  }
  getParkingZoneSpotGeoJsonFilter(params: any): Observable<any> {
    return this.httpClient.get<any[]>(`${this.parkingUrl}/parking-spot/format-geo-json`);
    
    //return this.httpClient.get<any[]>( 'assets/mock/parking-spot-3.json', { params });
 
  }
  getParkingZoneUndergroundGeoJson(): Observable<any> {
    //return this.httpClient.get<any[]>(`${this.parkingUrl}/off-street-parking/format-geo-json`);
     return this.httpClient.get<any[]>( 'assets/mock/parkingLot.json');
    //return this.httpClient.get<any[]>( 'assets/mock/off-street-parking-3.json');

  }

  getParkingStreeGeoJson(params: { categories?: string[] }): Observable<any> {
    const url = `${this.parkingUrl}/on-street-parking/format-geo-json`;
    //const url = 'assets/mock/on-street-parking-3.json';
    // const params = (colorLine && colorLine.length) ? { categories: colorLine } : {};
    return this.httpClient.get<any[]>(url, { params });
  }

  getParkingLoadingZoneGeoJson(): Observable<FeatureCollection<MultiPolygon>[]> {
    const url = `${this.runwayUrl}/runway/${NameRunwayFileEnum.CARGA_DESCARGA_ZONE}`;
    return this.httpClient.get<FeatureCollection<MultiPolygon>[]>(url);
  }

  getGroupLineMapper(parkingLine: { GeoLineBlue: any, GeoLineGreen: any }): ILayerModel[] {
    const processFeature = (features: any[], color: string) => features.map(feature => ({
      type: feature.type,
      geometry: feature.geometry,
      properties: {
        ...feature.properties,
        id: feature.id,
        color: color,
        type: 'ParkingLine'
      }
    }));

    const geoLineBlue = processFeature(parkingLine.GeoLineBlue?.features || [], '#458EFB');
    const geoLineGreen = processFeature(parkingLine.GeoLineGreen?.features || [], '#04C200');

    const source = [{
      type: 'FeatureCollection',
      features: [...geoLineBlue, ...geoLineGreen],
    }];

    return [{
      marker: source[0].features.map(ParkingLineFromApiMapper),
      geometryType: GeometryTypeEnum.MultiLineString,
      feature: source,
      visibility: true,
    }];
  }

  getParkingLineZoneMapper(parkingSource: any): ILayerModel[] {
    const source: any = {
      type: 'FeatureCollection',
      features: this.groupSourceByCoordinates(parkingSource.features),
    };

    return [{
      marker: source.features.map(ParkingSpotFromApiMapper),
      geometryType: GeometryTypeEnum.Point,
      feature: source,
      visibility: true,
    }];
  }

  getParkingLoadingZoneMapper(parkingSource: any): ILayerModel[] {
    const source: any = {
      type: 'FeatureCollection',
      features: parkingSource.features.map((e: any) => ({
        ...e,
        properties: {
          ...e.properties,
          type: 'ParkingLoadingZone'
        }
      })),
    };

    return [{
      marker: source.features.map(ParkingLoadingZoneFromApiMapper),
      geometryType: GeometryTypeEnum.MultiPolygon,
      feature: source,
      visibility: true,
    }];
  }

  private groupSourceByCoordinates(source: any[]): any[] {
    const points = source.reduce((acc, curr) => {
      const key = curr.geometry.coordinates.join('_');
      acc[key] = acc[key] || [];
      acc[key].push(curr.properties);
      return acc;
    }, {});

    return Object.entries(points).map(([coordinates, properties]) => ({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: coordinates.split('_').map(Number) },
      properties: properties,
    }));
  }

  public setFilter(filter: { source: MapLayers, filters: any }): void {
    this.filter$.next(filter);
  }

  public getFilter(): Observable<{ source: MapLayers, filters: any }> {
    return this.filter$.asObservable();
  }

  getLineOcupaiyty(idRef:any): Observable<any> {
    return this.httpClient.get<any[]>(`${this.parkingUrl}/parking-spot/spots-available/${idRef}`);
  }

}
